import { render, staticRenderFns } from "./PublishedIndicator.vue?vue&type=template&id=06a058ad"
import script from "./PublishedIndicator.vue?vue&type=script&lang=js"
export * from "./PublishedIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports